import React, { useState, useEffect } from "react";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const ok = localStorage.getItem("sms_rodo_ok");
    if (!ok) setOpen(true);
  }, []);

  const accept = () => {
    localStorage.setItem("sms_rodo_ok", "1");
    setOpen(false);
  };

  if (!open) return null;
  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 inset-x-0 z-[60] bg-[#1F1F1F] border-t-2 border-[#FFCC00] p-5 md:p-6"
    >
      <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row items-start md:items-center gap-4 md:gap-6">
        <div className="flex-1 text-sm text-white/80 leading-relaxed">
          <span className="font-display text-[#FFCC00] mr-2">RODO / COOKIES.</span>
          Strona korzysta z plików cookies w celu zapewnienia poprawnego działania oraz analizy ruchu.
          Twoje dane są przetwarzane zgodnie z RODO (Rozporządzenie UE 2016/679) oraz polską ustawą o ochronie danych osobowych.
          Administratorem danych jest Śląski Maker Space, Plebiscytowa 15, Katowice. Korzystając ze strony wyrażasz zgodę na używanie cookies.
        </div>
        <div className="flex gap-3 flex-shrink-0">
          <a
            href="/regulamin"
            className="font-mono-acc text-[11px] uppercase px-4 py-3 border border-[#3a3a3a] text-white/70 hover:border-white"
            data-testid="cookie-more-link"
          >
            Dowiedz się więcej
          </a>
          <button
            onClick={accept}
            data-testid="cookie-accept-btn"
            className="bg-[#FFCC00] text-black font-display text-xs px-6 py-3 btn-brutal"
          >
            AKCEPTUJĘ
          </button>
        </div>
      </div>
    </div>
  );
}
